import { useCallback } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { ButtonPrimary } from '~/components/Buttons'

import { REWARD_FEATURE } from '~/gamification/types/gamification.types'
import { useSetRewardsMutation } from '~/redux/apis/reward-api'

import checklistAnalytics from '~/analytics/checklist/checklistAnalytics'

import BadgeXP from './BadgeXP'

interface Props {
  handleClick: () => void
}

export default function CompletedChest({ handleClick }: Props): React.ReactElement {
  const { t } = useTranslation('dashboard')

  const [setRewards] = useSetRewardsMutation()

  const handleClaimReward = useCallback(() => {
    setRewards({
      xp: 2000,
      kudos: 0,
      gems: 0,
      feature: REWARD_FEATURE.CHECKLIST,
      event_id: `${REWARD_FEATURE.CHECKLIST}#${REWARD_FEATURE.COMPLETED_CHECKLIST}`,
    })
    checklistAnalytics.logChecklistCompleted()
    checklistAnalytics.logChecklistRewardClaim(2000)
    handleClick()
  }, [setRewards, handleClick])

  return (
    <div className="flex flex-col items-center my-4">
      <ResponsiveImage alt="claim-reward" height={70} srcKey="icons/checklist/chest-icon.webp" width={91} />
      <BadgeXP className="bg-orange-xp my-2" xp={2000} />
      <ButtonPrimary className="h-10 mt-2 px-4" onClick={handleClaimReward} size="medium">
        {t('checklists.button.claimReward')}
      </ButtonPrimary>
    </div>
  )
}
